import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable()
export class CryptoEncService {

  tokenFromUI: string = 'TYASuite!#!TYASuite!TYASuite!#!@';

  constructor() { }

  encrypt(value) {
    let _key = CryptoJS.enc.Utf8.parse(this.tokenFromUI);
    let _iv = CryptoJS.enc.Utf8.parse(this.tokenFromUI).toString();
    return CryptoJS.AES.encrypt(value.trim(), _key, {
      keySize: 256,
      iv: _iv,
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }).toString();
  }

  decrypt(value) {
    let _key = CryptoJS.enc.Utf8.parse(this.tokenFromUI);
    let _iv = CryptoJS.enc.Utf8.parse(this.tokenFromUI).toString();
    return CryptoJS.AES.decrypt(value.trim(), _key, {
      keySize: 256,
      iv: _iv,
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }).toString(CryptoJS.enc.Utf8);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3478285113/src/src/app/shared/services/crypto-enc.service.ts